import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ToggleThreePosition } from './components/threePositions/toggleThreePosition';
import { ToggleTwoPosition } from './components/twoPositions/toggleTwoPositions';
const ToggleStandAloneComponent = ({ hasThreePositions, ...props }, ref) => {
    return !hasThreePositions ? (_jsx(ToggleTwoPosition, { ...props, ref: ref })) : (_jsx(ToggleThreePosition, { ...props, ref: ref }));
};
/**
 * @description
 * Toggle component is a component that can be used to switch between two states.
 * @param {React.PropsWithChildren<IToggleStandAlone>} props
 * @returns {JSX.Element}
 */
export const ToggleStandAlone = React.forwardRef(ToggleStandAloneComponent);
//# sourceMappingURL=toggleStandAlone.js.map